// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepper {
  display: flex;
  position: relative;
  justify-content: space-between;
  padding-right: 15px;
  z-index: 1;
}

.stepperWrapper {
  display: inline-flex;
  align-items: center;
  background-color: #fff;
  padding: 5px 5px;
}

.stepperItem {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 11px;
  list-style: none;
  position: relative;
  width: 100%;
}

.stepperItem:first-child {
  justify-content: start;
}

.stepperItem:last-child {
  justify-content: end;
}

.stepperItem::before {
  content: "";
  position: absolute;
  display: block;
  background: rgba(0, 0, 0, 0.5019607843);
  z-index: -1;
}

.stepperItem:first-child:before,
.stepperItem:last-child:before {
  top: 50%;
  bottom: 50%;
  width: 185%;
  height: 2px;
}

.stepperItem:first-child:before {
  left: 0px;
}

.stepperItem:last-child:before {
  right: 0px;
}

/* pending step css */
.stepperItem.active ~ li::before {
  background: rgba(0, 0, 0, 0.5019607843);
}

.itemWrapper {
  color: var(--gray-900, #1F1F1F);
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Source Sans Pro;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 10px;
  /* 83.333% */
  padding-right: 20px;
}

.itemWrapper.active {
  color: #919191;
}

.stepperItem:first-child.activeLineFist::before {
  background-color: #58C3BB;
}

.stepperItem:last-child.activeLineLast::before {
  background-color: #58C3BB;
}`, "",{"version":3,"sources":["webpack://./styles.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;AACJ;;AAGA;EACI,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAAJ;;AAGA;EACI,sBAAA;AAAJ;;AAGA;EACI,oBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,kBAAA;EACA,cAAA;EACA,uCAAA;EACA,WAAA;AAAJ;;AAIA;;EAEI,QAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;AADJ;;AAIA;EACI,SAAA;AADJ;;AAIA;EACI,UAAA;AADJ;;AAIA,qBAAA;AACA;EACI,uCAAA;AADJ;;AAIA;EACI,+BAAA;EACA,kBAAA;EACA,6CAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAKA;EACI,yBAAA;AAFJ;;AAKA;EACI,yBAAA;AAFJ","sourcesContent":[".stepper {\n  display: flex;\n  position: relative;\n  justify-content: space-between;\n  padding-right: 15px;\n  z-index: 1;\n}\n\n.stepperWrapper {\n  display: inline-flex;\n  align-items: center;\n  background-color: #fff;\n  padding: 5px 5px;\n}\n\n.stepperItem {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 11px;\n  list-style: none;\n  position: relative;\n  width: 100%;\n}\n\n.stepperItem:first-child {\n  justify-content: start;\n}\n\n.stepperItem:last-child {\n  justify-content: end;\n}\n\n.stepperItem::before {\n  content: \"\";\n  position: absolute;\n  display: block;\n  background: rgba(0, 0, 0, 0.5019607843);\n  z-index: -1;\n}\n\n.stepperItem:first-child:before,\n.stepperItem:last-child:before {\n  top: 50%;\n  bottom: 50%;\n  width: 185%;\n  height: 2px;\n}\n\n.stepperItem:first-child:before {\n  left: 0px;\n}\n\n.stepperItem:last-child:before {\n  right: 0px;\n}\n\n/* pending step css */\n.stepperItem.active ~ li::before {\n  background: rgba(0, 0, 0, 0.5019607843);\n}\n\n.itemWrapper {\n  color: var(--gray-900, #1F1F1F);\n  text-align: center;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-family: Source Sans Pro;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 10px;\n  /* 83.333% */\n  padding-right: 20px;\n}\n\n.itemWrapper.active {\n  color: #919191;\n}\n\n.stepperItem:first-child.activeLineFist::before {\n  background-color: #58C3BB;\n}\n\n.stepperItem:last-child.activeLineLast::before {\n  background-color: #58C3BB;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
